<template>
  <div class="settings">
    <Navbar />
    <div class="mt-5 pt-5 kova-width">
        <div class="text-left pl-0 pl-md-5 mt-3 ml-5 mb-4"><a-icon class="mr-1" type="arrow-left" /> <span class="go-back">Go Back</span></div>
        <div class="px-1 px-md-4 px-lg-5 mx-lg-4 my-5">
            <div class="bg-light border p-2 p-md-4 add-rounded">
            <h5 class="font-weight-bolder text-left">Settings</h5>
            <a-tabs defaultActiveKey="1" @change="callback">
                <a-tab-pane tab="Profile" key="1">
                  <div class="mt-4">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-5 col-lg-4">
                        <div class="">
                          <div class="border add-rounded p-2">
                            <div class="add-rounded bg-white py-4">
                              <img src="../assets/kovatek/dev.png" alt="" class="rounded-circle img-height" />
                              <div class="d-flex mt-3 px-lg-3 justify-content-center">
                                <a-upload @change="upload"
                                  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                  class="mt-1">
                                  <span class="py-2 px-3 light-blue kova-text rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap">Upload new photo</span>
                                </a-upload>
                                <span class="font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer">Remove</span>
                              </div>
                            </div>
                          </div>
                          <div class="mt-3 pb-3">
                            <a-tooltip placement="topLeft">
                             <template slot="title">
                                  <span><a-icon class="mr-2" type="info-circle" style="position:relative; bottom: 3px;font-size: 16px;"/>click to copy</span>
                              </template>
                              <span class="ml-2">
                                  <span class="kova-bg-green py-1 px-3 text-white rounded ctrl-font-2">https://kovatek.com/mike</span>
                              </span>
                            </a-tooltip>
                          </div>
                        </div>
                        
                      </div>
                      <div class="col-12 col-sm-12 col-md-7 col-lg-8">
                        <div class="border add-rounded p-4">
                          <div class="d-flex">
                            <div>
                              <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">First Name</h6>
                              <a-input size="large" class="ml-1 font-weight-bolder" v-model="data.Firstname" required/>
                            </div>
                            <div class="ml-3">
                              <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font" >Surname</h6>
                              <a-input size="large" class="ml-1 font-weight-bolder" v-model="data.Surname" required/>
                            </div>
                          </div>

                          <!-- <div>
                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Email</h6>
                            <div class="d-flex">
                              <a-input size="large" class="ml-1 font-weight-bolder" v-model="data.Email" required/>
                              <img v-if="emailVerified" class="ml-1 ml-md-2 mb-1 mt-2" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                            </div>
                          </div> -->
                          <div>
                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Work Email</h6>
                            <div class="d-flex">
                              <a-input size="large" class="ml-1 font-weight-bolder" v-model="data.Email" required/>
                              <img v-if="emailVerified" class="ml-1 ml-md-2 mb-1 mt-2" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                            </div>
                          </div>
                          <div>
                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Phone Number</h6>
                            <div class="d-flex">
                              <a-input size="large" class="ml-1 font-weight-bolder" v-model="data.Phone" required/>
                              <img v-if="phoneVerified" class="ml-1 ml-md-2 mb-1 mt-2" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                            </div>
                          </div>

                          <div class="d-flex">
                            <div>
                              <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Country</h6>
                                <a-select
                                class="w-100 mb-3"
                                size="large"
                                placeholder="Please select your Country"
                                v-model="data.Country"
                                required
                              >
                                <a-select-option
                                  :value="item.name"
                                  v-for="(item, index) in countries"
                                  :key="index"
                                >{{item.name}}</a-select-option>
                              </a-select>
                             <!--  <a-input size="large" class="ml-1 font-weight-bolder" v-model="data.Country" required/> -->
                            </div>
                            <div class="ml-3">
                              <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font" >City</h6>
                               <a-select
                              class="w-100 mb-3"
                              size="large"
                              placeholder="Please select your City"
                              v-model="data.City"
                            >
                              <a-select-option
                                :value="item.name.replace(/ State/g, '')"
                                v-for="(item, index) in states"
                                :key="index"
                              >{{ item.name.replace(/ State/g, '') }}</a-select-option>
                            </a-select>
                             <!--  <a-input size="large" class="ml-1 font-weight-bolder" v-model="data.City" required/> -->
                            </div>
                          </div>
                          
                          <div class="d-flex mt-4 px-lg-3 justify-content-start">
                                <span class="py-2 px-3 kova-bg text-white rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap" @click="updateProfile">Save changes</span>
                                <span class="font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer">Cancel</span>
                              </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </a-tab-pane>
                <a-tab-pane tab="Password & Security" key="2" forceRender>
                  <div class="mt-4">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="border add-rounded p-4">
                          <h6 class="font-weight-bolder text-left mb-4">Change Password</h6>
                          <div>
                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Old Password</h6>
                            <div class="d-flex">
                              <a-input size="large" type="password" class="ml-1 font-weight-bolder" v-model="oldPassword" required/>
                            </div>
                            
                          </div>

                          <div>
                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">New Password</h6>
                            <div class="d-flex">
                              <a-input size="large" type="password" class="ml-1 font-weight-bolder" v-model="newPassword" required/>
                            </div>
                          </div>

                          <div>
                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Confirm Password</h6>
                            <div class="d-flex">
                              <a-input size="large" type="password" class="ml-1 font-weight-bolder" v-model="confirmPassword" required/>
                            </div>
                          </div>

                          <div class="d-flex mt-4 px-lg-3 justify-content-start">
                                <span class="py-2 px-3 kova-bg text-white rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap" @click="updatePassword">Save changes</span>
                                <span class="font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer">Cancel</span>
                              </div>
                        </div>
                        
                      </div>
                      <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="border add-rounded p-4">
                          <div class="d-flex">
                              <div class="text-left mr-auto"><h6 class="font-weight-bolder text-left">Two Factor Authentication</h6> </div>
                              <div class="">
                                  <div class="input-group mb-3">
                                      <input type="button" value="Add More" class="btn-kovatek new-bank py-1 px-3" />
                                      <div class="input-group-append btn-kovatek plus-btn-icon py-1 px-2">
                                          <a-icon type="plus" style="position: relative;bottom: -3px;"/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div>
                            <div class="d-flex">
                              <a-input size="large" class="ml-1 font-weight-bolder"  value="Google" disabled />
                              <img v-if="emailVerified" class="ml-1 ml-md-2 mb-1 mt-2" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                            </div>
                          </div>
                          <div>
                            <div class="d-flex mt-3">
                              <a-input size="large" class="ml-1 font-weight-bolder" value="Github" disabled />
                              <img v-if="emailVerified" class="ml-1 ml-md-2 mb-1 mt-2" style="height:22px;" src="../assets/kovatek/correct.svg" alt="" />
                            </div>
                          </div>
                        </div>
                        <div class="d-flex mt-5 px-lg-3 justify-content-end">
                          <span class="py-2 px-3 light-blue kova-text rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap">Delete my Account</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-tab-pane>
                <a-tab-pane tab="Card & Payments" key="3">
                  <div class="bg-light border p-2 p-md-4">
                    <div class="row">
                      <div class="col-12 col-md-12 col-lg-6">
                        <h5 class="font-weight-bolder text-left">Billing and Payments</h5>
                        <h6 class="text-left mt-4">Current Balance</h6>
                        <h6 class="font-weight-bolder text-left">Your balance is ${{wallet.LedgerBalance}}</h6>
                      </div>
                      <div class="col-12 col-md-12 col-lg-6">
                        <h6 class="text-left mt-5">Current Balance</h6>
                        <h6 class="font-weight-bolder text-left">Your balance is 5.90 BTC</h6>
                      </div>
                    </div>
                    
                  </div>
                  <div class="mx-3 add-rounded">
                    <div class="row">
                        <div class="col-12 col-md-12 col-lg-6 bg-light">
                            <div class="row">
                                <div class="col-12 col-md-12 col-lg-11 border border-top-0">
                                    <div class="my-4">
                                        <!-- <div class="d-flex">
                                            <div class="text-left mr-auto"><h6 class="font-weight-bolder text-left ml-3">Card</h6> </div>
                                            <div class="">
                                                <div class="input-group mb-3">
                                                    <input type="button" value="Add a new bank" class="btn-kovatek new-bank py-1 px-3" />
                                                    <div class="input-group-append btn-kovatek plus-btn-icon py-1 px-2">
                                                        <a-icon type="plus" style="position: relative;bottom: -3px;"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> -->
                                        <div class="px-1 px-md-3 ">
                                          <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Amount to deposit</h6>
                                          <a-input-group compact class="text-left" size="large">
                                          <a-select style="line-height: 38px;" v-model="currency" default-value="USD">
                                            <a-select-option value="USD">USD</a-select-option>
                                            <!-- <a-select-option value="NGN">NGN</a-select-option>
                                            <a-select-option value="EUR">EUR</a-select-option>
                                            <a-select-option value="GBP">GBP</a-select-option> -->
                                          </a-select>
                                       
                                          <a-input-number size="large" :precision="number" placeholder="1000" class="ml-1 font-weight-bolder" v-model="amountToDeposit" />
                                        </a-input-group>
                                           <!--  <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Card Holder Name</h6>
                                            <a-input size="large" class="ml-1 font-weight-bolder" v-model="cardName" />
                                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font" >Card Number</h6>
                                            <a-input size="large" class="ml-1 font-weight-bolder" v-model="cardNumber" />
                                           
                                            <div class="d-flex">
                                            <div>
                                                <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Expiry Date</h6>
                                                <a-input size="large" type="date" class="ml-1 font-weight-bolder" v-model="date" required/>
                                                </div>
                                                <div class="ml-3">
                                                <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font" >CVC</h6>
                                                <a-input size="large" class="ml-1 font-weight-bolder" v-model="cvc" required/>
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>
                                    <div class="d-flex mt-4 px-lg-3 justify-content-start mb-4">
                                       
                                       <span class="py-2 px-3 kova-bg text-white rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap" @click="payViaService">Click to pay</span> 
                                    <!--   <span class="font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer mr-auto">Cancel</span>
                                      <span class="py-2 px-3 light-blue kova-text rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap">Delete</span> -->
                                    </div>
                                </div>
                                <div class="col-12 col-md-12 col-lg-1 bg-white"></div>
                            </div>
                        </div>

                        <div class="col-12 col-md-12 col-lg-6 bg-light border border-top-0">
                            <div class="my-4">
                             <div class="d-flex">
                                  <div class="text-left mr-auto"><h6 class="font-weight-bolder text-left">Crypto</h6> </div>
                                  <div class="">
                                      <div class="input-group mb-3">
                                          <input type="button" value="Add new address" class="btn-kovatek new-bank py-1 px-3" />
                                          <div class="input-group-append btn-kovatek plus-btn-icon py-1 px-2">
                                              <a-icon type="plus" style="position: relative;bottom: -3px;"/>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="px-1 px-md-3 ">
                                  <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Wallet Address</h6>
                                  <a-input size="large" class="ml-1 font-weight-bolder" v-model="walletAddress" />
                                  
                              </div>
                            </div>
                            <div class="d-flex mt-4 px-lg-3 justify-content-start mb-4">
                              <span class="py-2 px-3 kova-bg text-white rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap">Save changes</span>
                              <span class="font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer mr-auto">Cancel</span>
                              <span class="py-2 px-3 light-blue kova-text rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap">Delete</span>
                            </div>
                        </div>
                    </div>
                </div >
                </a-tab-pane>
                <a-tab-pane tab="Notifications" key="4" forceRender>
                  <!-- <input type="checkbox" id="id-name--1" name="set-name" class="switch-input" checked>
                  <label for="id-name--1" class="switch-label">  -->
                    <!-- <span class="toggle--on">On</span><span class="toggle--off">Off</span> -->
                    <!-- </label> -->
                    <div class="mt-4">
                      <div class="row">
                      <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="border add-rounded p-4">
                          <h6 class="font-weight-bolder text-left mb-4">Activities</h6>
                          <div class="d-flex mt-2">
                            <div class="mr-auto">
                              <p class="kova-light ctrl-font">Comments added to ongoing projects</p>
                            </div>
                            <div class="">
                              <input type="checkbox" id="id-name--1" name="" class="switch-input" v-model="ActivitiesNewsletter" >
                              <label for="id-name--1" class="switch-label my-0 py-0"> 
                                </label>
                            </div>
                          </div>
                          <div class="d-flex mt-2">
                            <div class="mr-auto">
                              <p class="kova-light ctrl-font">Milestone added to an ongoing project</p>
                            </div>
                            <div class="">
                              <input type="checkbox" id="id-name--2" name="" class="switch-input" v-model="ActivitiesPaymentReceipt" >
                              <label for="id-name--2" class="switch-label my-0 py-0"> 
                                </label>
                            </div>
                          </div>
                          <div class="d-flex mt-2">
                            <div class="mr-auto">
                              <p class="kova-light ctrl-font">New Project uploaded</p>
                            </div>
                            <div class="">
                              <input type="checkbox" id="id-name--3" name="" class="switch-input" v-model="ActivitiesNewProjectUploaded" >
                              <label for="id-name--3" class="switch-label my-0 py-0"> 
                                </label>
                            </div>
                          </div>
                          <div class="d-flex mt-2">
                            <div class="mr-auto">
                              <p class="kova-light ctrl-font">Added as a new member to a project</p>
                            </div>
                            <div class="">
                              <input type="checkbox" id="id-name--4" name="" class="switch-input" v-model="ActivitiesNewMemberAdded" >
                              <label for="id-name--4" class="switch-label my-0 py-0"> 
                                </label>
                            </div>
                          </div>
                          <div class="d-flex mt-2">
                            <div class="mr-auto">
                              <p class="kova-light ctrl-font">Milestone approved</p>
                            </div>
                            <div class="">
                              <input type="checkbox" id="id-name--5" name="" class="switch-input" v-model="ActivitiesNewMemberAdded" >
                              <label for="id-name--5" class="switch-label my-0 py-0"> 
                                </label>
                            </div>
                          </div>
                          <div class="d-flex mt-4 px-lg-3 justify-content-start">
                                <span class="py-2 px-3 kova-bg text-white rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap">Save changes</span>
                                <span class="font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer">Cancel</span>
                              </div>
                        </div>
                        
                      </div>
                      <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="border add-rounded p-4">
                          <h6 class="font-weight-bolder text-left mb-4">Emails</h6>
                          
                          <div class="d-flex mt-2">
                            <div class="mr-auto">
                              <p class="kova-light ctrl-font">Kovatek Weekly Newsletters</p>
                            </div>
                            <div class="">
                              <input type="checkbox" id="id-name--6" name="" class="switch-input" v-model="data.EmailNewsletter" >
                              <label for="id-name--6" class="switch-label my-0 py-0"> 
                                </label>
                            </div>
                          </div>
                          <div class="d-flex mt-2">
                            <div class="mr-auto">
                              <p class="kova-light ctrl-font">Payment Receipts</p>
                            </div>
                            <div class="">
                              <input type="checkbox" id="id-name--7" name="" class="switch-input" v-model="data.EmailPaymentReceipt">
                              <label for="id-name--7" class="switch-label my-0 py-0"> 
                                </label>
                            </div>
                          </div>
                          <div class="d-flex mt-2">
                            <div class="mr-auto">
                              <p class="kova-light ctrl-font">New Project uploaded</p>
                            </div>
                            <div class="">
                              <input type="checkbox" id="id-name--8" name="" class="switch-input" v-model="data.EmailNewProjectUploaded" >
                              <label for="id-name--8" class="switch-label my-0 py-0"> 
                                </label>
                            </div>
                          </div>
                          <div class="d-flex mt-2">
                            <div class="mr-auto">
                              <p class="kova-light ctrl-font">Added as a new member to a project</p>
                            </div>
                            <div class="">
                              <input type="checkbox" id="id-name--9" name="" class="switch-input" v-model="data.EmailMilestoneApproved" >
                              <label for="id-name--9" class="switch-label my-0 py-0"> 
                                </label>  
                            </div>
                          </div>
                          <div class="d-flex mt-2">
                            <div class="mr-auto">
                              <p class="kova-light ctrl-font">Milestone approved</p>
                            </div>
                            <div class="">
                              <input type="checkbox" id="id-name--10" name="" class="switch-input" v-model="data.EmailNewMemberAdded" >
                              <label for="id-name--10" class="switch-label my-0 py-0"> 
                                </label>  
                            </div>
                          </div>
                          <div class="d-flex mt-4 px-lg-3 justify-content-start">
                                <span class="py-2 px-3 kova-bg text-white rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap" @click="updateNotification">Save changes</span>
                                <span class="font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer">Cancel</span>
                              </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-tab-pane>
                <a-tab-pane tab="Account" key="5">
                  <div class="mt-4">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                        <div class="border add-rounded p-4">
                          <!-- <h6 class="font-weight-bolder text-left mb-4">Change Password</h6> -->
                          <div>
                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Preferred Language</h6>
                            <div class="">
                              <a-select class="w-100 ctrl-font" size="large" placeholder="Enter/Choose skills" v-model="data.Language">
                              <a-select-option v-for="lang in languages" :key="lang"
                              >{{lang}}</a-select-option
                              ></a-select>
                              <!-- <a-input size="large" class="ml-1 font-weight-bolder" v-model="data.Language"/> -->
                            </div>
                            
                          </div>

                          <div>
                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Preferred Currency</h6>
                            <div class="d-flex">
                              <a-select class="w-100 ctrl-font" size="large" placeholder="Enter/Choose skills" v-model="data.Currency">
                              <a-select-option v-for="currency in currencies" :key="currency"
                              >{{currency}}</a-select-option
                              ></a-select>
                              <div class="kova-bg-green py-2 px-2 rounded ml-2 text-white" style="white-space: nowrap">$1 = N366</div>
                            </div>
                          </div>

                          <div>
                            <h6 class="font-weight-lighter text-left kova-light ml-2 mt-3 ctrl-font">Tell a Friend</h6>
                            <div class="">
                              <a-input size="large" class="ml-1 font-weight-bolder" v-model="data.InviteLink" id="profileLink">
                                <a-tooltip slot="suffix" :title="copyStatus">
                                  <span class="pointer ant-color font-weight-lighter" @click="copy">copy</span>
                                </a-tooltip>
                              </a-input>
                            </div>
                          </div>

                          <div class="mt-3 kova-text d-flex">
                            <p class="font-weight-bolder ml-3 pointer">
                            <a-icon type="question-circle" class="pointer mr-1" theme="filled" style="font-size: 20px; position: relative; bottom: 2px"/>
                              Help</p>
                              <p class="font-weight-bolder ml-4 pointer">
                            <font-awesome-icon icon="comment-alt" class="pointer mr-1" style="font-size: 20px; position: relative; bottom: -2px"/>
                              Send Feedback</p>
                          </div>

                          <div class="d-flex mt-5 px-lg-3 justify-content-start">
                                <span class="py-2 px-3 kova-bg text-white rounded font-weight-bolder ctrl-font pointer" style="white-space:nowrap" @click="updateAccount">Save changes</span>
                                <span class="font-weight-bolder bg-light py-2 px-3 rounded ctrl-font ml-3 pointer">Cancel</span>
                              </div>
                        </div>
                        
                      </div>
                      <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                      </div>
                    </div>
                  </div>
                </a-tab-pane>
            </a-tabs>
        </div>
        </div>
    </div>
    <Footer />
  </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import countries from "@/plugins/countries.json";
import axios from "axios";
import { uuid } from 'vue-uuid';


export default {
  name: 'settings',
  components: {
   Navbar, Footer
  },
  data(){
      return {
        loading: true,
        wallet: null,
        stacks: ['Web Developer', 'Mobile App', 'Front-End', 'Back-End', 'DevOps', 'Data Engineer', 'Block Chain', 'A.I', 'CyberSecurity', 'UI/UX'],
        languages: ['English'],
        currencies: ['US Dollars', 'NGN'],
        emailVerified: true,
        phoneVerified: true,
        walletAddress: 'Sadbsajgduqe82ey23ey230ee',
        oldPassword: '',
        newPassword:'',
        confirmPassword:'',
        // profileLink: 'https://kovatek.com/mike/invite',
        copyStatus: 'click to copy',
        ActivitiesNewsletter: false,
        ActivitiesPaymentReceipt: false,
        ActivitiesNewProjectUploaded: false,
        ActivitiesMilestoneApproved: false,
        ActivitiesNewMemberAdded: false,
        countries,
        data: {
          ID: "",
          CreatedAt: "",
          UpdatedAt: "",
          DeletedAt: null,
          UserID: "",
          Avatar: "",
          Email: "",
          Firstname: "",
          Surname: "",
          Phone: "",
          City: "",
          Country: "",
          Skills: [],
          AccountName: "",
          AccountNumber: Number,
          BankName: "",
          Language: "",
          Currency: "",
          InviteLink: "",
          EmailNewsletter: Boolean,
          EmailPaymentReceipt: Boolean,
          EmailNewProjectUploaded: Boolean,
          EmailMilestoneApproved: Boolean,
          EmailNewMemberAdded: Boolean
        },
        message:'',
        error:'',
        response: {},
        amount: null,
        amountToDeposit: null,
        currency: 'USD',
        convertedAmount: null,
      }
  },
  methods: {
    payViaService() {
      if (this.currency !== 'USD') {
        const param = {
        respCurrency: this.currency,
      }
        this.$store.dispatch("profiles/getExchangeRate", param)
        .then(resp => {
          this.convertedAmount = resp.data.rates.USD.rate * this.amountToDeposit;
        })
        .catch(err => {
          this.message = err
          // console.log(err.message, err.response)
        })
      }
      else {
        this.convertedAmount = this.amountToDeposit;
      }
      this.payWithFlutterwave(this.paymentData) 
    },
     makePaymentCallback(response) {
      /* console.log("Payment callback", response) */
        try {
           const config = {
          headers: {
            "Content-type": "application/json"
          }
        };
        const body = JSON.stringify({ currency: response.currency, txRef: response.tx_ref, amount: this.convertedAmount });
         axios.defaults.withCredentials = true;
         axios.post("https://api.kovatek.com/payments/verify", body, config);
        /* console.log('final result: ' + JSON.stringify(result)); */
          
        } catch (err) {
          /* console.log('final error: ' + err); */
          this.error  = err;
        }
    },
    closedPaymentModal() {
      /* console.log('payment modal is closed'); */
      /* alert('payment modal is closed') */
      this.$toast.fire({
            icon: 'success',
            title: 'Payment processed!',
          });
       this.$router.go();
      /* this.$forceUpdate(); */
    },
    generateReference(){
      /* let date = new Date()
      return date.getTime().toString(); */
      return uuid.v4();
    },
      callback(){
    

      },
      goback: () => {
          this.$router.go(-1)
      },
      upload(){

      },
      copy(){
        let copy = document.querySelector('#profileLink')
        copy.setAttribute('type', 'text');
        copy.select();
        
        try{
          let successful = document.execCommand('copy')
          let msg = successful? 'copied' : 'copy failed'
          this.copyStatus = msg
        } catch (err) {
          this.copyStatus = 'unable to copy'
        }
      },
      getAllSettings(){
        this.$store.dispatch("settings/userSettings")
        .then(resp => {
          // console.log(resp)
          this.data = { ...resp.data }
          // console.log({ ...resp.data } )
        })
        .catch(err => {
          this.message = err
          // console.log(err.message, err.response)
        })
      },
      updateSettings(user){
        this.$store.dispatch("settings/updateSettings", user)
          .then((resp) => {
            this.response = { ...resp }
            // console.log("Success")
            // console.log(resp)
            this.getAllSettings();
          })
          .catch(err => {
            this.message = err
            // console.log(err.message, err.response)
          })
      },

      updateProfile(){
        const user = {
          type: 'profile',
          data: {
            Firstname: this.data.Firstname,
            Surname: this.data.Surname,
            Email: this.data.Email,
            Phone: this.data.Phone,
            City: this.data.City,
            Country: this.data.Country,
            Skills: this.data.Skills
          }
        }
        this.updateSettings(user);
      },

      updatePayment(){
        const user = {
          type: 'payment',
          data: {
            AccountName: this.data.AccountName,
            AccountNumber: this.data.AccountNumber,
            BankName: this.data.BankName,
          }
        }
        this.updateSettings(user);
      },

      updateAccount(){
        const user = {
          type: 'account',
          data: {
            Language: this.data.Language,
            Currency: this.data.Currency,
          }
        }
        this.updateSettings(user);
      },

      updateNotification(){
        const user = {
          type: 'notification',
          data: {
            email_newsletter: this.data.EmailNewsletter,
            email_payment_receipt: this.data.EmailPaymentReceipt,
            email_new_project_uploaded: this.data.EmailNewProjectUploaded,
            email_milestone_approved: this.data.EmailMilestoneApproved,
            email_new_member_added: this.data.EmailNewMemberAdded,
          }
        }
        this.updateSettings(user);
      },

      updatePassword(){
        const isValid = this.newPassword !== this.confirmPassword || this.newPassword === '' || this.confirmPassword === '' ;
        
        if(!isValid){
          const data = {
                        old_password: this.oldPassword,
                        new_password: this.newPassword
                      }

          this.$store.dispatch("settings/updatePassword", data)
            .then((resp) => {
                this.message = resp.data;
              })
            .catch(err => {
                // console.log(err)
                this.error = err.message
            });

        } else {
            this.error = "invalid or incomplete inputs"
        }
      }
      
    },
    computed: {
    states() {
          const country = this.countries.find(key => key.name === this.data.Country);
          return country ? country.states : [];
        },
          paymentData() {
      return {
        tx_ref: this.generateReference(),
        amount: this.amountToDeposit,
        currency: this.currency,
        payment_options: 'card,ussd',
        redirect_url: '',
        meta: {
          'counsumer_id': '7898',
          'consumer_mac': 'kjs9s8ss7dd'
        },
        customer: {
          name: this.data.Firstname + this.data.Surname,
          email: this.data.Email,
          phone_number: this.data.Phone
        } ,
        customizations: {
          title: 'Kovatek Deposit',
          description: 'Kovatek deposit',
          logo: 'https://flutterwave.com/images/logo-colored.svg'
        },
        callback: this.makePaymentCallback,
        onclose: this.closedPaymentModal
      }
    }
    },
    mounted(){
      this.$store.dispatch("settings/userSettings")
      .then(resp => {
         /* console.log(resp) */
        // this.response = { ...resp.data }
        this.data = { ... resp.data }
        // console.log({ ...resp.data } )
      })
      .catch(err => {
        this.message = err;
        // console.log(err.message, err.response)
      })

      this.$store.dispatch("profiles/getWallet").then( resp => {
        this.wallet = { ...resp.data }
        /* console.log(resp) */
      }).catch( err => {
        /* console.log(err.message) */
        this.error = err.message
        this.loading = false
      })
  }
}
</script>

<style scoped>

.ant-select-selection__rendered {
    line-height: 38px !important;
}
.kova-width{
    max-width: 1350px;
    margin:auto
}
.img-height{
  width: 160px;
  height: 160px;
}
.ctrl-font{
  font-size: 11px;
}
.ctrl-font-2{
  font-size: 13px;
}
.new-bank{
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
}
.plus-btn-icon{
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border-left: solid 1px #fff;
}

/* styling switch */

.switch-input {
  display: none;
}
.switch-label {
  position: relative;
  display: inline-block;
  min-width: 50px;
  cursor: pointer;
  font-weight: 500;
  text-align: left;
  margin: 16px;
  padding: 16px 0 16px 44px;
}
.switch-label:before, .switch-label:after {
  content: "";
  position: absolute;
  margin: 0;
  outline: 0;
  top: -7px;
  -ms-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.switch-label:before {
  left: 1px;
  width: 34px;
  height: 14px;
  background-color: #cbcbcb;
  border-radius: 8px;
}
.switch-label:after {
  left: 0;
  width: 20px;
  height: 20px;
  background-color: #FAFAFA;
  border-radius: 50%;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.098), 0 1px 5px 0 rgba(0, 0, 0, 0.084);
}
/* .switch-label .toggle--on {
  display: none;
}
.switch-label .toggle--off {
  display: inline-block;
} */
.switch-input:checked + .switch-label:before {
  background-color:rgba(32, 64, 154, 0.25);
}
.switch-input:checked + .switch-label:after {
  background-color: #20409a;
  -ms-transform: translate(80%, -50%);
  -webkit-transform: translate(80%, -50%);
  transform: translate(80%, -50%);
}


/* .switch-input:checked + .switch-label .toggle--on {
  display: inline-block;
}
.switch-input:checked + .switch-label .toggle--off {
  display: none;
} */
</style>
